export const DATADOG_APPLICATION_ID = 'dfe15876-b32a-4684-b918-0a7d4c623fba';
export const DATADOG_CLIENT_TOKEN = 'pub188d5a096a04a4b063a2aa6de446e4f4';

/** Must match `--service` on `datadog-ci sourcemaps upload`. */
export const DATADOG_SERVICE = 'mind-oasis-web-app';
